import { CloseOutlined } from '@ant-design/icons';
import React, { FC, useState } from 'react';
import { batch } from 'react-redux';
import { GraphicActionType } from '../../../model/GraphicModel';
import { useStoreDispatch, useStoreSelector } from '../../../store';
import { setGraphicActionType, setMapDirectoryDataAction, setMapHasChangedAction } from '../../../store/graphic/actions';
import { graphicActionTypeSelector, mapHasChangedSelector, mapInfoSelector } from '../../../store/graphic/selectors';
import { ModalConfirmCustomFooter } from '../../common';
import styles from './floatingItems.module.scss';

export const MapNamesBar: FC = () => {
	const dispatch = useStoreDispatch();
	const [showWarning, setShowWarning] = useState<boolean>(false);
	const { Name } = useStoreSelector(mapInfoSelector);
	const mapHasChanged: boolean = useStoreSelector<boolean>(mapHasChangedSelector);
	const graphicActionType: GraphicActionType = useStoreSelector<GraphicActionType>(graphicActionTypeSelector);

	const handleOnCloseMap = () => {
		if (mapHasChanged) {
			setShowWarning(true);
		} else {
			handleOnOk();
		}
	};

	const handleOnOk = () => {
		batch(() => {
			setShowWarning(false);
			dispatch(setMapHasChangedAction(false));
			dispatch(setMapDirectoryDataAction({ Id: -1, Name: '' }));
			dispatch(setGraphicActionType(graphicActionType | GraphicActionType.ModalDirectory));
		});
	};

	return (
		<div className={styles.mapNamesBarContainer}>
			<ModalConfirmCustomFooter
				title={_('DataModified')}
				width={'400px'}
				visible={showWarning}
				onOk={handleOnOk}
				onCancel={() => setShowWarning(false)}
				onNo={handleOnOk}>
				<span>{_('MapHasChanged')}</span>
			</ModalConfirmCustomFooter>
			{Name && (
				<div className={styles.name}>
					{Name}
					<CloseOutlined className={styles.icon} onClick={handleOnCloseMap} />
				</div>
			)}
		</div>
	);
};
